<template>
  <div>
   
    <router-view></router-view>
  </div>
</template>

<script>

export default {
  name: "StudentPanel",
  
  methods: {
    getStudent() {
      axios.get(apiRoutes.AdmissionForm.check).then((response) => {
        if (response.data == 0) {
          this.$router.replace({
            name: "AdmissionForm",
          });
        }
      });
    },
  },

  created() {
    this.getStudent();
  },
};
</script>

<style scoped></style>
